import { IAgent } from '~/types/agent'
import http from '~/utils/http'

export function getAgent(page: number, size: number) {
  return http.get('/admin/agent', {
    params: {
      page,
      size,
    },
  })
}

export function postAgent(data: Partial<IAgent>) {
  return http.post('/admin/agent', data)
}

export function deleteAgent(id: number) {
  return http.delete(`/admin/agent/${id}`)
}

export function patchAgent(id: number, data: Partial<IAgent>) {
  return http.patch(`/admin/agent/${id}`, data)
}

export function postChangePassword(
  id: number,
  password: string,
  oldPassword: string,
) {
  return http.patch(`/admin/agent/password/${id}`, {
    password,
    oldPassword,
  })
}
